var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHome = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63069 17.3096V14.754C6.63067 14.1039 7.16061 13.5758 7.81718 13.5714H10.2222C10.882 13.5714 11.4168 14.1009 11.4168 14.754V14.754V17.3175C11.4166 17.8694 11.8616 18.3205 12.4189 18.3334H14.0222C15.6206 18.3334 16.9163 17.0506 16.9163 15.4683V15.4683V8.19828C16.9078 7.57577 16.6126 6.99121 16.1147 6.61094L10.6311 2.23783C9.67045 1.47639 8.30484 1.47639 7.34419 2.23783L1.8847 6.61888C1.38489 6.9976 1.08916 7.58314 1.08301 8.20621V15.4683C1.08301 17.0506 2.37874 18.3334 3.9771 18.3334H5.58048C6.15164 18.3334 6.61465 17.875 6.61465 17.3096V17.3096",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.6619f92a.svg";
export { ForwardRef as ReactComponent };